export const CBTKD_ID = "4X8eTXc3fCjlGFQPJ3gi";
